export const getSlugFromSlugsByKey = (slugs: string[], key: string) => {
  const slugsLength = slugs.length
  if (slugs[slugsLength - 1].includes(key)) {
    return slugs[slugsLength - 1]
  }
}
